import React from "react";

interface SectionHeaderProps {
  id?: string;
  title: string;
  actionLabel?: string;
  onAction?: () => void;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ id, title, actionLabel, onAction }) => {
  const baseId = id || 'section-header';

  return (
    <div id={baseId} data-testid={baseId} className='tw-flex tw-justify-between tw-border tw-border-[#DFE0E6] tw-px-[22px] tw-py-[13px] tw-mt-[16px]'>
      <div id={`${baseId}-title`} className="tw-text-[#747493] tw-text-sm tw-font-semibold tw-font-['Noto_Sans'] tw-leading-tight">
        {title}
      </div>
      {actionLabel && onAction && (
        <div
          id={`${baseId}-action-btn`}
          data-testid={`${baseId}-action-btn`}
          onClick={onAction}
          className="tw-text-center tw-text-[#091caa] tw-text-sm tw-font-normal tw-leading-tight tw-cursor-pointer"
        >
          {actionLabel}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;